(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-trike-landing"] && !Shopify.designMode) return;
  try {
    
function initTrikeLanding(scope) {
  scope.querySelectorAll('[data-trike-landing]').forEach(root => {
    if (root.dataset.trikeLandingReady) return;
    root.dataset.trikeLandingReady = 'true';
    const bar = root.querySelector('[data-trike-mobile]');
    const booking = document.getElementById(root.dataset.booking);
    if (!bar || !booking || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => { bar.hidden = entries[0].isIntersecting; }, { threshold: 0 });
    observer.observe(booking);
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) observer.disconnect(); });
  });
}
initTrikeLanding(document);
document.addEventListener('shopify:section:load', event => initTrikeLanding(event.target));

  } catch(e) { console.error(e); }
})();
})();
